export default function CanadaInfoSection() {
    return (
        <>
            {/* Main Colored Section */}
            <section className="w-full bg-[#C67B3E] py-12 px-4 sm:px-6 lg:px-16">
                <div className="max-w-7xl mx-auto text-center lg:text-left">

                    {/* Heading */}
                    <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-6">
                        Best Canada Student Visa Consultant in Ahmedabad
                    </h3>

                    {/* Paragraph 1 */}
                    <p className="text-justify text-base sm:text-lg text-white/90 leading-relaxed max-w-6xl mx-auto lg:mx-0 mb-6">
                        If you are living in Gujarat and dreaming of studying in Canada, 
                        you don’t need to worry. Our expert team of Canada Education 
                        Consultants in Ahmedabad provides personalized guidance to help 
                        you understand every important step before beginning your 
                        international education journey. From selecting the right course 
                        and institution to preparing visa documentation, we assist you 
                        at every stage.
                    </p>

                    {/* Paragraph 2 */}
                    <p className="text-justify text-base sm:text-lg text-white/90 leading-relaxed max-w-6xl mx-auto lg:mx-0">
                        When applying for a Canada Student Visa, students often face 
                        challenges related to accommodation, financial planning, 
                        scholarships, tuition waivers, and documentation requirements. 
                        These factors are crucial for a smooth and successful study 
                        abroad experience. With the support of a trusted and reputable 
                        Canada Student Visa Consultant in Ahmedabad, you can confidently 
                        navigate these challenges and significantly improve your visa 
                        approval chances.
                    </p>

                </div>
            </section>
        </>
    );
}